'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');

const DropdownItemView = Mn.View.extend(
    /**
     * @lends module:balus/views/typeahead-view.TypeaheadView.DropdownItemView.prototype
     */
    {
        tagName: 'li',
        className: 'list-item',
        template: null,
        activeClass: 'is-active',

        /**
         * TypeaheadView 用の itemView。
         *
         * template を使って model.toJSON() を render する。
         * @example
         * var MyItemView = TypeaheadView.DropdownItemView.extend({
             *     template: mytemplate
             * })
         * @constructs
         */
        initialize: function() {
            this.listenTo(this.model, 'remove', this.remove);
            this.listenTo(this.model, 'active', this.active);
            this.listenTo(this.model, 'deactive', this.deactive);
        },

        active: function() {
            this.$el.addClass(this.getOption('activeClass'));
        },

        deactive: function() {
            this.$el.removeClass(this.getOption('activeClass'));
        }
    });

/**
 * 検索時に呼ばれるコールバック
 *
 * query が渡されるので、マッチする Backbone.Model の配列を返す。
 * 配列が空か、null が返ると検索がマッチしなかったと判断する。
 * また、function を返すと callback で Model の配列が渡されると判断する。
 * @callback module:balus/views/typeahead-view.TypeaheadView~find
 * @param {String} query - 検索文字列
 */

/**
 * 検索結果が選択された時に呼ばれるコールバック
 *
 * 選択された Model が渡されるので、update 用の文字列を返す。
 * query が返された文字列で置き換えられる。
 * @callback module:balus/views/typeahead-view.TypeaheadView~onselectCallback
 * @param {Backbone.Model} model - 選択された Model
 */

/**
 * @exports balus/views/typeahead-view
 */
module.exports = Mn.View.extend(
    /**
     * @lends module:balus/views/typeahead-view.TypeaheadView.prototype
     */
    {
        events: {
            'keyup': 'keyup',
            'keypress': 'keypress',
            'keydown': 'keydown',
            'blur': 'blur',
            'focus': 'search'
        },

        minLength: 2,
        topOffset: 0,

        /**
         * 入力にマッチした結果をリアルタイムに dropdown で表示して選択、入力するための View。
         *
         * 流れは以下
         * 1. 入力された文字列が search メソッドに渡される
         * 2. query メソッドで query に変換される
         * 3. query が存在しないか、長さが minlength 未満なら dropdown を非表示に
         * 4. 上記のチェックを通過したら、query を find コールバックに渡す
         * 5. find コールバックから query にマッチする dropdown 用 item を返す
         * 6. マッチした item が無ければ dropdown を非表示にする
         * 7. item に対して view を生成して dropdown を表示
         * 8. dropdown が選択されたら、選択された item を引数として update コールバックが呼ばれる
         * 9. update コールバックで処理を行い、置換え用の文字列を返す
         * 10. 返された文字列を使って文字を置き換え
         *
         * 上下キーが押されるか itemView にカーソルが乗ると、
         * 該当の view に紐付いた model に対して
         * 'active' イベントが発火される。
         *
         * @constructs
         * @param {Object} params
         * @param {(string|jQuery)} params.el - TypeaheadView の listen 対象となる element
         * @param {TypeaheadView~find} params.find - 検索時に呼ばれるコールバック
         * @param {TypeaheadView~update} params.update - item が選択された際に呼ばれるコールバック
         * @param {TypeaheadView~enter} params.enter - item 未選択時に enter が押下された際に呼ばれるコールバック
         * @param {Backbone.View} itemView - ドロップダウンリストの Item View
         * @param {number} [params.minlength=2] - 検索を行う最小の長さのキーワード
         */
        initialize: function(params) {
            if(!params.el) {
                throw new Error('No el is specified.');
            }
            if(!params.find) {
                throw new Error('No find callback is specified.');
            }
            if(!params.update) {
                throw new Error('No update callback is specified.');
            }
            if(!params.itemView) {
                throw new Error('No itemView is specified.');
            }

            this.setElement(params.el);
            this.find = params.find;
            this.update = params.update;
            this.enter = params.enter || function(){};
            this.itemView = params.itemView;

            this._query = '';

            this.collection = new Backbone.Collection();
            this.listenTo(this.collection, 'add', this.addOne);
            _.bindAll(this, 'addOne', 'change', 'search');

            this.$menu = $(`<ul class="list dropdown-menu" style="overflow-y: scroll;"></ul>`);
            this.active = null;
            this.$el.on('input', this.change);
            this.$el.parent().css('position', 'relative');
            if(this.getOption('showOnFocus')) {
                this.$el.on('focus', this.search);
            }
        },

        addOne: function(model) {
            let option = this.childViewOptions ? this.childViewOptions : {};
            option = _.extend({model: model},
                _.isFunction(option) ? _.bind(option, this)() : option);
            var view = new this.itemView(option);
            this.$menu.append(view.render().el);
            view.$el.mouseenter(_.bind(function(){
                this.activate(view.model);
            }, this));
            view.$el.mousedown(_.bind(function(){
                this.active = view.model;
                this.select();
            }, this));
        },

        /**
         * 入力文字列から query を生成して返す。
         * ここでは単純に value を返している。
         */
        query: function() {
            return this.$el.val().trim();
        },

        search: function() {
            this._query = this.query();
            if(!_.isString(this._query) ||
                (_.isString(this._query) &&
                    this._query.length < this.getOption('minLength'))) {
                this.hide();
                return;
            }
            var items = this.find(this._query);
            if(_.isFunction(items)) {
                items(_.bind(function(items){
                    this.updateItems(items);
                }, this));
            } else {
                this.updateItems(items);
            }
        },

        updateItems: function(items) {
            if(!items || items.length == 0) {
                this.hide();
                return;
            }

            this.collection.set(items);
            if(this.active && !this.collection.contains(this.active)) {
                this.active = null;
            }
            this.show();
        },

        select: function() {
            var pos = this.$el[0].selectionStart;
            var val = this.$el.val();
            var textBefore = val.slice(0, pos - this._query.length);
            var textAfter = val.slice(pos);
            var data = this.update(this.active);
            this.$el.val(textBefore + data + textAfter);
            this.hide();
            this.$el.trigger('keyup');
        },

        show: function () {
            var pos = $.extend({}, this.$el.position(), {
                height: this.$el[0].offsetHeight
            });

            this.$menu
                .insertAfter(this.$el)
                .css({
                    top: pos.top + pos.height + this.getOption('topOffset'),
                    left: pos.left,
                })
                .show();

            this.$menu.css({
                'max-height': $(window).height() - this.$menu.offset().top
            });
            this.shown = true;
            return this
        },

        hide: function() {
            this.$menu.hide();
            this.$menu.empty();
            this.collection.remove(this.collection.models, {silent: true});
            this.shown = false;
            return this;
        },

        activate: function(model) {
            if(this.active) {
                this.active.trigger('deactive');
            }

            this.active = model;
            model.trigger('active');
        },

        next: function () {
            // Collection が空なら何もしない
            if(this.collection.length == 0) {
                return;
            }

            var idx = 0;
            if(this.active) {
                idx = this.collection.indexOf(this.active) + 1;
                if(idx == this.collection.length) {
                    idx = 0;
                }
            }

            this.activate(this.collection.at(idx));
        },

        prev: function () {
            // Collection が空なら何もしない
            if(this.collection.length == 0) {
                return;
            }

            var idx = this.collection.length - 1;
            if(this.active) {
                idx = this.collection.indexOf(this.active) - 1;
                if(idx == -1) {
                    idx = this.collection.length - 1;
                }
            }

            this.activate(this.collection.at(idx));
        },

        move: function (e) {
            if (!this.shown){
                return;
            }

            switch(e.keyCode) {
                case 38: // up arrow
                    e.preventDefault();
                    this.prev();
                    break;

                case 40: // down arrow
                    e.preventDefault();
                    this.next();
                    break;
            }

            e.stopPropagation()
        },

        keydown: function(e) {
            this.onIME = false;
            this._prevVal = this.$el.val();

            this.move(e);
            // enter key が押され、かつドロップダウンが選択されている場合は
            // その選択操作とみなして enter を入力しない
            if(e.keyCode == 13 && this.$menu.find('.is-active').length) {
                this.select();
                this.selected = true;
                return false;
                // IME の入力
            } else if(e.keyCode == 229) {
                this.onIME = true;
            } else {
                return true;
            }
        },

        keypress: function() {
        },

        keyup: function (e) {
            var selected = this.selected;
            this.selected = false;

            switch(e.keyCode) {
                case 40: // down arrow
                case 39: // right arrow
                case 38: // up arrow
                case 37: // left arrow
                case 16: // shift
                case 17: // ctrl
                case 18: // alt
                    break;

                case 9: // tab
                    if (!this.shown) {
                        return;
                    }
                    this.select();
                    break;

                case 27: // escape
                    if (!this.shown) {
                        return;
                    }
                    this.hide();
                    break;

                case 13: // enter
                    if(!this.onIME && !selected && this.$menu.find('.is-active').length == 0) {
                        var text = this.enter(this.query());
                        if(text != undefined) {
                            this.$el.val(text);
                        }
                        this.hide();
                    }
                    break;

                default:
                    if(!this.onIME) {
                        this.search();
                    }
            }
        },

        change: function() {
            if(this.onIME && this._prevVal == this.$el.val()) {
                this.search();
            }
        },

        blur: function() {
            this.hide();
        }
    }, {
        DropdownItemView: DropdownItemView
    });




// WEBPACK FOOTER //
// ./common/ui/view/typeahead.js